// extracted by mini-css-extract-plugin
module.exports = {"Footer":"LeagueRoster_Footer__aTJ3V","FooterActions":"LeagueRoster_FooterActions__2aJyI"};